import {
  NEW_FIELD_FIELD_CHANGE,
  OPEN_NEW_FIELD_DIALOG,
  CLOSE_NEW_FIELD_DIALOG,
  ADD_NEW_FIELD,
  NEW_FIELD_ADDED,
} from './actions';

const initialState = {
  pending: false,
  isDirty: false,
  open: false,
  error: null,
  isValid: true,
  data: null,
  name: {
    value: '',
    isValid: null,
  },
  options: {
    value: '',
    isValid: null,
  },
  type: {
    value: '',
    isValid: null,
  },
  isMultiple: {
    value: false,
  },
  isRequired: {
    value: false,
  },
  isSearchable: {
    value: false,
  },
  isPublic: {
    value: false,
  },
};

const newGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_NEW_FIELD_DIALOG:
      return {
        ...state,
        open: true,
      };

    case CLOSE_NEW_FIELD_DIALOG:
      return {
        ...state,
        open: false,
      };

    case NEW_FIELD_FIELD_CHANGE:
      return {
        ...state,
        [action.prop]: {
          value: action.value,
          isValid: action.isValid,
        },
      };

    case ADD_NEW_FIELD:
      return {
        ...state,
        pending: true,
      };

    case NEW_FIELD_ADDED:
      return initialState;

    default:
      return state;
  }
};

export default newGroupReducer;
